export default __webpack_public_path__ + "static/media/election2019municipal.4f2ec0e0.txt";